import React, { memo } from 'react';
import { Flex, View } from '@adobe/react-spectrum';
import { useSelector } from 'react-redux';
import { selectCompact } from 'app/pages/Home/slice/selectors';
import roadmapStyles from 'app/components/RoadmapCard/Roadmap.module.scss';
import { MonthSection } from './MonthSection';
import { TimelineControls } from './TimelineControls';
import type { MonthSectionWidth } from '../utils/useMonthSectionWidths';
import styles from '../MonthlyRoadmap.module.scss';

interface MonthlyTimelineHeaderProps {
  monthSections: MonthSectionWidth[];
  bodyExtensionPx: number;
  gapWidth: number;
  onToggleMonthExpanded: (monthKey: string) => void;
  isMustWinView?: boolean;
}

export const MonthlyTimelineHeader = memo(
  ({
    monthSections,
    bodyExtensionPx,
    gapWidth,
    onToggleMonthExpanded,
    isMustWinView
  }: MonthlyTimelineHeaderProps) => {
    const isCompact = useSelector(selectCompact);

    return (
      <Flex
        data-testid="monthly-timeline-sticky-header"
        UNSAFE_style={{
          position: 'sticky',
          top: 0,
          zIndex: 100,
          background: 'inherit',
          minWidth: 'max-content'
        }}
      >
        <View
          data-testid="monthly-timeline-controls-section"
          backgroundColor="gray-50"
          UNSAFE_className={`${styles.controlsSection} ${
            isMustWinView ? styles.controlsSectionMustWin : ''
          }`}
          UNSAFE_style={{
            borderBottom: '1px solid #E8E8E8'
          }}
        >
          <TimelineControls />
        </View>

        <View
          data-testid="monthly-timeline-months-container"
          UNSAFE_className={roadmapStyles.quarterContainer}
          UNSAFE_style={{
            display: 'flex',
            zIndex: 10,
            borderBottom: '1px solid #E6E6E6',
            padding: '10px 0',
            height: '74px',
            backgroundColor: '#ffffff',
            paddingLeft: '10px'
          }}
        >
          <Flex direction="row">
            {monthSections.map(section => (
              <MonthSection
                key={section.month.key}
                month={section.month}
                isExpanded={section.isExpanded}
                isCompact={isCompact}
                onToggle={onToggleMonthExpanded}
                widthPx={section.widthPx}
              />
            ))}
          </Flex>
        </View>

        {bodyExtensionPx > 0 && (
          <div
            data-testid="monthly-timeline-header-body-extension"
            className={styles.monthlyHeaderBodyExtension}
            style={{ width: `${bodyExtensionPx}px` }}
          />
        )}

        <div
          data-testid="monthly-timeline-header-gap-filler"
          className={roadmapStyles.whiteGapFiller}
          style={{ width: gapWidth ? `${gapWidth}px` : undefined }}
        />
      </Flex>
    );
  }
);
